<template>
  <!-- 应用bottomcolor作为背景颜色，添加渐变效果 -->
  <div class="page-container" :style="{
    'color': textColor
  }" :class="{ 'has-bg-image': backgroundImageUrl }">
    <div class="background-layer" :style="{ 'background-image': `url(${backgroundImageUrl})` }"></div>
    <!-- 用户登录/信息区域 - 更现代化的设计 -->
    <div class="user-area">
      <div class="user-info-box" v-if="isLoggedIn">
        <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
          <el-avatar :size="45" :src="userInfo.face" class="user-avatar" />
          <div class="user-badge">
            <el-icon>
              <StarFilled />
            </el-icon>
          </div>
        </div>

        <transition name="el-zoom-in-top">
          <div v-if="showDropdown" class="user-dropdown-menu">
            <div class="dropdown-header">
              <el-avatar :size="52" :src="userInfo.face" class="dropdown-avatar" />
              <div class="user-details">
                <h3>{{ userInfo.uname }}</h3>
                <p class="user-id">UID: {{ userInfo.mid }}</p>
                <p class="user-integral">积分: {{ settingData.Integral }}</p>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <div class="dropdown-item" @click="logout2">
              <el-icon>
                <SwitchButton />
              </el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>

      <div class="login-entry" v-else>
        <el-button type="primary" size="small" @click="goToLogin" :icon="User" class="login-button">
          登录
        </el-button>
      </div>
    </div>

    <!-- 导航栏 - 玻璃拟态设计 -->
    <nav class="navbar">
      <ul class="nav-list">
        <li class="nav-item" v-for="item in shownNav" :key="item.path" :class="{ 'active': isActive(item.path) }">
          <router-link :to="item.path"
            :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
            <el-icon :size="18" class="nav-icon">
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- 主内容区域 - 卡片玻璃拟态效果 -->
    <div class="link-integral-container" :style="{ '--theme-color': settingData.color || '#ffffff' }">
      <el-card class="main-card glass-effect" shadow="hover" :style="{ 'background-color': cardBackgroundColor }">
        <template #header>
          <div class="header-title">
            <el-icon class="title-icon">
              <Link />
            </el-icon>
            <span>技术支持</span>
          </div>
        </template>

        <!-- 技术支持内容区域 -->
        <div class="tech-support-content">
          <!-- 开发者信息 -->
          <div class="developer-info">
            <h2 class="section-title">技术开发者</h2>
            <div class="developer-card glass-effect">
              <div class="developer-avatar">
                <el-image 
                  src="/img/image.png" 
                  fit="cover"
                  :preview-src-list="['/img/image.png']"
                  :preview-teleported="true"
                  style="cursor: pointer;" />
              </div>
              <div class="developer-details">
                <h3>寒梦洛花</h3>
                <p class="developer-desc">全栈开发者，负责本项目的技术实现与维护</p>

                <div class="developer-links">
                  <a :href="developerBilibili" target="_blank" rel="noopener noreferrer" class="developer-link">
                    <el-button type="primary" :icon="Platform" circle />
                    <span>B站主页</span>
                  </a>
                  <a :href="developerAfdian" target="_blank" rel="noopener noreferrer" class="developer-link">
                    <el-button type="success" :icon="Shop" circle />
                    <span>爱发电支持</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- 技术栈信息 -->
          <div class="tech-stack">
            <h2 class="section-title">技术栈</h2>
            <div class="tech-grid">
              <div class="tech-item glass-effect" v-for="(tech, index) in techStack" :key="index">
                <div class="tech-icon">
                  <img :src="tech.icon" :alt="tech.name" />
                </div>
                <div class="tech-info">
                  <h4>{{ tech.name }}</h4>
                  <p>{{ tech.desc }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 项目信息 -->
          <div class="project-info">
            <h2 class="section-title">项目信息</h2>
            <el-card shadow="hover" class="glass-effect">
              <div class="project-details">
                <div class="project-item">
                  <h4>项目名称</h4>
                  <p>虚拟主播个人空间系统</p>
                </div>
                <div class="project-item">
                  <h4>项目描述</h4>
                  <p>为虚拟主播打造的个性化个人空间，包含作品管理、积分兑换、舰长礼物、歌单展示、直播路灯、小黑屋等功能模块。</p>
                </div>
                <div class="project-item">
                  <h4>项目特点</h4>
                  <ul>
                    <li>响应式设计，适配各种设备</li>
                    <li>美观的UI界面，高度可定制</li>
                    <li>完善的后台管理系统</li>
                    <li>丰富的互动功能</li>
                  </ul>
                </div>
              </div>
            </el-card>
          </div>

          <!-- 联系支持 -->
          <div class="contact-support">
            <h2 class="section-title">联系支持</h2>
            <el-card shadow="hover" class="glass-effect">
              <div class="contact-methods">
                <div class="contact-item">
                  <el-icon>
                    <Message />
                  </el-icon>
                  <span>邮箱：672958743@qq.com</span>
                </div>
                <div class="contact-item">
                  <el-icon>
                    <ChatDotRound />
                  </el-icon>
                  <span>B站私信：寒梦洛花</span>
                </div>
                <div class="contact-item">
                  <el-icon>
                    <HelpFilled />
                  </el-icon>
                  <span>站外反馈：请提供详细描述和截图 联系QQ：</span>{{ QQData.QQ }}
                </div>
              </div>
            </el-card>
          </div>
        </div>



      </el-card>
    </div>
  </div>

  <div class="floating-button-container">
    <el-tooltip content="反馈" placement="left">
      <el-button class="floating-button" type="primary" circle :style="{ width: '56px', height: '56px' }"
        @click="handleClick">
        <el-icon size="30">
          <Service />
        </el-icon>
      </el-button>
    </el-tooltip>
  </div>

  <!-- 反馈表单对话框 -->
  <el-dialog v-model="floatingVisible" title="用户反馈" width="500px" custom-class="feedback-dialog"
    :close-on-click-modal="false">
    <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackFormRef" label-width="100px">
      <el-form-item label="你的B站UID" prop="userId">
        <el-input v-model="feedbackForm.userId" placeholder="请输入你的用户ID"></el-input>
      </el-form-item>

      <el-form-item label="问题类型" prop="problemType">
        <el-select v-model="feedbackForm.problemType" placeholder="请选择问题类型">
          <el-option label="加群审核" value="加群审核"></el-option>
          <el-option label="禁言申诉" value="禁言申诉"></el-option>
          <el-option label="私信补发" value="私信补发"></el-option>
          <el-option label="音声礼物" value="音声礼物"></el-option>
          <el-option label="物流相关" value="物流相关"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="问题描述" prop="problemDesc">
        <el-input v-model="feedbackForm.problemDesc" type="textarea" :rows="4" placeholder="请详细描述你的问题..."></el-input>
      </el-form-item>

      <el-form-item label="QQ联系方式" prop="contactInfo">
        <el-input v-model="feedbackForm.contactInfo" placeholder="请留下联系方式以便回复"></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="floatingVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
      </span>
    </template>
  </el-dialog>

    <!-- 在template部分的最后，floating-button-container之后添加备案号 -->
  <div class="footer-record">
    <div class="record-text" :style="{ 'color': textColor }">
      <a href="https://beian.miit.gov.cn/" target="_blank" :style="{ 'color': textColor }">
        陕ICP备2025066285号-2
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import {
  Link, Search, User, StarFilled, SwitchButton, Picture, Service,
  HomeFilled, Calendar, Collection, Present, Headset, InfoFilled, Coin,
  Platform, Shop, Message, ChatDotRound, HelpFilled
} from '@element-plus/icons-vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { ASSET_BASE } from '../../util/assetBase';

const route = useRoute();
const router = useRouter();
const QQData = reactive({
  QQ: ''
})
const fetchData = async () => {
  try {
    var str = await axios.get('/adminapi/setting/list')
    const d = str.data?.results?.[0] || {}
    console.log(d.QQ)
    QQData.QQ = d.QQ || ''
  } catch (error) {
    console.error('获取QQ信息失败:', error)
    QQData.QQ = ''
  }
}
onMounted(() => {
  fetchData();
});
// 导航项配置
const navItems = [
  { path: '/', name: '首页', icon: HomeFilled },
  { path: '/works', name: '作品', icon: Collection },
  { path: '/points', name: '积分兑换', icon: Coin },
  { path: '/captain', name: '舰长礼物', icon: Present },
  { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/livecalendar', name: '直播日历', icon: 'Calendar' },
  { path: '/about', name: '关于', icon: InfoFilled }
];

// 一场直播记录都还没有的时候，导航里的「直播日历」就不出现（后台录一场，它自己就回来）
const liveCount = ref(0);
// 主人要求：直播日历这一项所有域名都显示（原来是「有直播记录才出现」，
// 结果子域名那几个库是空的，整个入口都看不见了）
const shownNav = computed(() => navItems.slice());
axios.get('/adminapi/live/list?_=' + Date.now()).then((r) => { liveCount.value = Number((r.data && r.data.count) || 0); }).catch(() => {});
const logout2 = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    ElMessage.success('已退出登录');
  } catch (error) {
    console.error('退出登录失败:', error);
  }
};
// 判断当前路由是否激活
const isActive = (path) => {
  return route.path === path;
};

// 计算文本颜色基于背景色
const textColor = computed(() => {
  const bgColor = settingData.bottomcolor || '#000000';
  // 简单计算背景亮度决定文字颜色
  const color = bgColor.replace('#', '');
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#333' : '#fff';
});

// 计算卡片背景颜色
const cardBackgroundColor = computed(() => {
  const bgColor = settingData.backcolor || 'rgba(255, 255, 255, 0.9)';
  if (bgColor.includes('rgba')) {
    // 如果是rgba，增加透明度
    return bgColor.replace(/[\d\.]+\)$/, '0.85)');
  }
  return bgColor;
});

// 用户信息
const isLoggedIn = ref(false);
const userInfo = reactive({
  uname: '',
  mid: '',
  face: ''
});
const showDropdown = ref(false);

// 点击空白处关闭下拉菜单
const handleClickOutside = (event) => {
  const userArea = document.querySelector('.user-area');
  if (userArea && !userArea.contains(event.target)) {
    showDropdown.value = false;
  }
};

// 检查登录状态
const checkLoginStatus = () => {
  const savedUserInfo = localStorage.getItem('userInfo');
  if (savedUserInfo) {
    try {
      const parsedInfo = JSON.parse(savedUserInfo);
      if (parsedInfo.mid) {
        Object.assign(userInfo, parsedInfo);
        isLoggedIn.value = true;
      }
    } catch (e) {
      console.error('解析用户信息失败:', e);
      localStorage.removeItem('userInfo');
    }
  }
};

// 登录跳转
const goToLogin = () => {
  router.push('/user/login');
};

// 退出登录
const logout = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }


  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

// 获取用户积分
const UserIntegral = async (usermid) => {
  try {
    const response = await axios.post('/adminapi/userapi/integral/check', {
      uid: usermid
    });
    settingData.Integral = response.data.results[0]?.integral || 0;
  } catch (error) {
    console.error('查询积分失败:', error);
    settingData.Integral = 0;
  }
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await axios.get('/adminapi/user/Bmsg', {
      withCredentials: true
    });

    if (response.data.code === 0 && response.data.data) {
      const userData = response.data.data;
      userInfo.uname = userData.uname || '';
      userInfo.mid = userData.mid || '';
      userInfo.face = await setBilibiliAvatar(userData.face);
      isLoggedIn.value = true;
      UserIntegral(userInfo.mid);

      localStorage.setItem('userInfo', JSON.stringify({
        uname: userInfo.uname,
        mid: userInfo.mid,
        face: userInfo.face
      }));
    } else {
      console.error("获取用户信息失败:", response.data.message);
      logout();
    }
  } catch (error) {
    console.error('请求用户信息失败:', error);
    logout();
  }
};

const setBilibiliAvatar = async (str) => {
  try {
    const response = await axios.post('/adminapi/user/avater', {
      face: str,
    }, {
      responseType: 'arraybuffer',
      withCredentials: true
    });

    const base64 = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    );

    return `data:image/jpeg;base64,${base64}`;
  } catch (error) {
    console.error('获取头像失败:', error);
    return '/default-avatar.png';
  }
}

// 主播信息数据
const settingData = reactive({
  nickname: '',
  slogan: '',
  homepageImage: '',
  color: '#ffffff',
  backcolor: 'rgba(255, 255, 255, 0.85)',
  Navigationcolor: 'rgba(0, 0, 0, 0.7)',
  bottomcolor: '#000000',
  Integral: 0
});

// 技术栈数据
const techStack = reactive([
  {
    name: 'Vue 3',
    desc: '前端框架，用于构建用户界面',
    icon: 'https://vuejs.org/images/logo.png'
  },
  {
    name: 'Express',
    desc: '后端框架，用于构建API服务',
    icon: 'https://www.expressrc.cn/img/logo.png'
  },
  {
    name: 'Element Plus',
    desc: 'UI组件库，提供美观的界面组件',
    icon: 'https://element-plus.org/images/element-plus-logo.svg'
  },
  {
    name: 'Axios',
    desc: 'HTTP客户端，用于前后端通信',
    icon: '/img/axios-logo.svg' // 原先指向 axios-http.com，该站已搬家，旧地址会 302 到首页返回 HTML，图片必挂；改成同源本地文件
  },
  {
    name: 'Node.js',
    desc: 'JavaScript运行时环境',
    icon: 'https://nodejs.org/static/images/logo.svg'
  },
  {
    name: 'MySQL',
    desc: '数据库系统，用于数据存储',
    icon: 'https://labs.mysql.com/common/logos/mysql-logo.svg?v2'
  }
]);
// 背景图片URL
const backgroundImageUrl = ref('');

// 获取主播信息和主题颜色
const fetchSettingData = async () => {
  try {
    const response = await axios.get('/adminapi/setting/list');
    const data = response.data.results[0] || {};

    settingData.nickname = data.title || '虚拟主播';
    settingData.slogan = data.content || '虚拟主播的个人空间';
    settingData.homepageImage = data.homepageImage || '';
    settingData.color = data.color || '#ffffff';
    settingData.backcolor = data.backcolor || 'rgba(255, 255, 255, 0.85)';
    settingData.Navigationcolor = data.Navigationcolor || 'rgba(0, 0, 0, 0.7)';
    settingData.bottomcolor = data.bottomcolor || '#000000';
    // 关于页「技术开发者」卡片上的两个链接（面板 dashboard.php 顶部那组输入框改的就是它们）
    developerLinks.homePage = data.about_bilibili || '';
    developerLinks.afdian = data.about_afdian || '';
    const defaultBackground = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
    backgroundImageUrl.value = data.page ? ASSET_BASE + data.page : defaultBackground;
  } catch (error) {
    console.error('加载设置数据错误:', error);
  }
};

/* ---------------- 技术开发者卡片里的两个外链 ----------------
 * 存在站点数据库 setting 表的 about_bilibili / about_afdian 两列，
 * 由后台面板 dashboard.php 顶部那组「关于页链接」输入框写入，
 * 通过公开接口 /adminapi/setting/list 读出来（就是下面 fetchSettingData 那一次请求）。
 * 注意别和 url 表的 Home_Page / afd 搞混：那两个是「主播自己的」主页与爱发电，
 * 首页气泡按钮、舰长页、礼物系统用的是那套。
 * 后台没填就退回开发者本人的主页，免得按钮变成死链。
 */
const DEFAULT_BILIBILI = 'https://space.bilibili.com/89334544';
const DEFAULT_AFDIAN = 'https://afdian.com/a/cold320537';
const developerLinks = reactive({ homePage: '', afdian: '' });
const developerBilibili = computed(() => String(developerLinks.homePage || '').trim() || DEFAULT_BILIBILI);
const developerAfdian = computed(() => String(developerLinks.afdian || '').trim() || DEFAULT_AFDIAN);

onMounted(() => {
  checkLoginStatus();
  fetchUserInfo();
  fetchSettingData();

  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

// 点击事件处理
const floatingVisible = ref(false);
// 反馈表单数据
const feedbackForm = reactive({
  userId: '',
  problemType: '',
  problemDesc: '',
  contactInfo: '',
  time: '',
  Solve: '未解决',
  id: ''
});
const generateId = () => {
  // 方法1: 使用时间戳和随机数生成唯一ID
  const timestamp = Date.now().toString(36)
  const random = Math.random().toString(36).substr(2, 5)
  var nameid = `${timestamp}${random}`
  return nameid

}
const feedbackFormRef = ref(null);
const feedbackRules = reactive({
  userId: [{ required: true, message: '请输入你的B站UID', trigger: 'blur' }],
  problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
  problemDesc: [{ required: true, message: '请描述你的问题', trigger: 'blur' }],
  contactInfo: [{ required: true, message: '请留下联系方式', trigger: 'blur' }]
});
const handleClick = () => {
  console.log('反馈按钮被点击')
  floatingVisible.value = true
}
const submitFeedback = async () => {
  // 表单声明了 :rules 却从不校验，空字段会直接写进 Feedback 表
  if (feedbackFormRef.value) {
    try {
      await feedbackFormRef.value.validate();
    } catch (e) {
      return; // 校验不通过，字段下方已有提示
    }
  }
  feedbackForm.time = formatTime(Date.now())
  feedbackForm.id = generateId()
  try {
    var response = await axios.post('/adminapi/Feedback/add', feedbackForm)
    if (response.data && response.data.code === 200) {
      floatingVisible.value = false
      ElMessage.success('反馈成功');
      resetFeedbackForm()
    } else {
      floatingVisible.value = false
      ElMessage.error((response.data && response.data.message) || '反馈失败');
    }
  } catch (error) {
    console.error('反馈提交失败:', error)
    floatingVisible.value = false
    ElMessage.error('反馈失败，请稍后重试');
  }
}
const formatTime = (time) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
};
const resetFeedbackForm = () => {
  feedbackForm.userId = '';
  feedbackForm.problemType = '';
  feedbackForm.problemDesc = '';
  feedbackForm.contactInfo = '';
  feedbackForm.time = '';
  feedbackForm.Solve = '未解决';
  feedbackForm.id = '';
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
:root {
  --glass-blur: 8px;
  --glass-border: 1px solid rgba(255, 255, 255, 0.18);
  --glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.page-container {
  min-height: 100vh;
  padding: 20px;
  position: relative;
  background: none !important;
  /* 移除任何背景设置 */
}

.page-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  opacity: 0.1;
  z-index: -1;
  /* 使用CSS变量动态设置背景图片 */
  background-image: var(--bg-image, url('https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg'));
}

.page-container.has-bg-image {
  background-image: url('');
  /* 这里通过JS动态设置 */
}

/* 用户区域样式 - 更现代化的设计 */
.user-area {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;

  .user-info-box {
    position: relative;

    .user-avatar-wrapper {
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05);

        .user-badge {
          transform: translate(30%, -30%) scale(1.2);
        }
      }

      .user-avatar {
        border: 2px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
      }

      .user-badge {
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(135deg, #ff4081, #7b1fa2);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        transform: translate(30%, -30%);
        transition: transform 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        z-index: 1;

        .el-icon {
          width: 12px;
          height: 12px;
        }
      }
    }

    .user-dropdown-menu {
      position: absolute;
      top: 60px;
      right: 0;
      width: 260px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      z-index: 200;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      .dropdown-header {
        padding: 20px;
        display: flex;
        background: linear-gradient(135deg, rgba(245, 247, 250, 0.8), rgba(228, 231, 235, 0.8));
        border-bottom: 1px solid rgba(238, 238, 238, 0.5);

        .dropdown-avatar {
          margin-right: 15px;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .user-details {
          flex: 1;

          h3 {
            margin: 0 0 5px;
            color: #333;
            font-weight: 600;
            font-size: 16px;
          }

          .user-id {
            margin: 0;
            color: #666;
            font-size: 12px;
          }

          .user-integral {
            margin: 5px 0 0;
            color: #e6a23c;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

      .dropdown-divider {
        height: 1px;
        background: rgba(238, 238, 238, 0.5);
        margin: 0 15px;
      }

      .dropdown-item {
        padding: 12px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(245, 247, 250, 0.8);
          color: #ff4081;

          .el-icon {
            color: #ff4081;
          }
        }

        .el-icon {
          margin-right: 10px;
          font-size: 16px;
          color: #777;
          transition: color 0.2s ease;
        }
      }
    }
  }
}

.login-entry {
  .login-button {
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(37, 117, 252, 0.4);

      .el-icon {
        transform: translateX(3px);
      }
    }

    .el-icon {
      transition: transform 0.3s ease;
    }
  }
}

/* 导航栏样式 - 玻璃拟态设计 */
.navbar {
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
  backdrop-filter: blur(var(--glass-blur));

  .nav-list {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    gap: 10px;
  }

  .nav-item {
    a {
      color: white;
      text-decoration: none;
      font-size: 15px;
      padding: 10px 18px;
      border-radius: 20px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      }

      &.router-link-active {
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
        font-weight: bold;
      }

      .nav-icon {
        margin-right: 8px;
      }
    }
  }
}

/* 玻璃拟态效果 */
.glass-effect {
  backdrop-filter: blur(var(--glass-blur));
  border: var(--glass-border) !important;
  box-shadow: var(--glass-shadow) !important;
  background: rgba(255, 255, 255, 0.85) !important;
}

.link-integral-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;

  .main-card {
    border-radius: 16px !important;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
    }
  }

  .header-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: var(--theme-color);
    padding: 10px 0;

    .title-icon {
      margin-right: 10px;
      color: var(--theme-color);
      font-size: 20px;
    }
  }
}

/* 技术支持内容样式 */
.tech-support-content {
  padding: 20px;

  .section-title {
    color: var(--theme-color);
    font-size: 22px;
    margin: 30px 0 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -1px;
      width: 50px;
      height: 2px;
      background: var(--theme-color);
    }
  }

  /* 开发者信息 */
  .developer-info {
    .developer-card {
      display: flex;
      align-items: center;
      padding: 25px;
      margin-bottom: 30px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
      }

      .developer-avatar {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 25px;
        border: 3px solid #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        position: relative;
        cursor: pointer;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        }

        &:hover::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .el-image {
          width: 100%;
          height: 100%;
        }
      }

      .developer-details {
        flex: 1;

        h3 {
          font-size: 24px;
          margin: 0 0 10px;
          color: var(--theme-color);
        }

        .developer-desc {
          color: #666;
          margin-bottom: 20px;
          font-size: 16px;
          line-height: 1.6;
        }

        .developer-links {
          display: flex;
          gap: 15px;

          .developer-link {
            display: flex;
            align-items: center;
            text-decoration: none;
            color: inherit;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-2px);

              span {
                color: var(--theme-color);
              }
            }

            .el-button {
              transition: all 0.3s ease;
            }

            span {
              margin-left: 8px;
              font-size: 14px;
              transition: color 0.3s ease;
            }
          }
        }
      }
    }
  }

  /* 技术栈 */
  .tech-stack {
    .tech-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 20px;

      .tech-item {
        display: flex;
        padding: 20px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
        }

        .tech-icon {
          width: 50px;
          height: 50px;
          margin-right: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: white;
          border-radius: 8px;
          padding: 5px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        }

        .tech-info {
          flex: 1;

          h4 {
            margin: 0 0 5px;
            font-size: 18px;
            color: var(--theme-color);
          }

          p {
            margin: 0;
            color: #666;
            font-size: 14px;
            line-height: 1.5;
          }
        }
      }
    }
  }

  /* 项目信息 */
  .project-info {
    .project-details {
      padding: 20px;

      .project-item {
        margin-bottom: 25px;

        h4 {
          color: var(--theme-color);
          margin-bottom: 10px;
          font-size: 18px;
          display: flex;
          align-items: center;

          &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 16px;
            background: var(--theme-color);
            margin-right: 10px;
            border-radius: 2px;
          }
        }

        p,
        ul {
          margin: 0;
          color: #333;
          line-height: 1.6;
          font-size: 15px;
        }

        ul {
          padding-left: 20px;

          li {
            margin-bottom: 8px;
            position: relative;

            &::before {
              content: '•';
              color: var(--theme-color);
              font-weight: bold;
              display: inline-block;
              width: 1em;
              margin-left: -1em;
            }
          }
        }
      }
    }
  }

  /* 联系支持 */
  .contact-support {
    .contact-methods {
      padding: 20px;

      .contact-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        font-size: 16px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateX(5px);
        }

        .el-icon {
          margin-right: 15px;
          color: var(--theme-color);
          font-size: 22px;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(var(--theme-rgb), 0.1);
          border-radius: 50%;
          padding: 5px;
        }
      }
    }
  }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .tech-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)) !important;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 15px 15px 70px;
  }

  /* 手机上内容比一屏长，底部留白给备案号和反馈按钮，别互相压住 */
  .floating-button-container { right: 12px; bottom: 74px; }

  .developer-card {
    .developer-avatar {
      width: 116px !important;
      height: 116px !important;
      box-sizing: border-box !important;   /* 3px 白边算进尺寸里，图片就不会被裁掉 5px */
      overflow: hidden;
      margin-bottom: 16px !important;

      img, .el-image { width: 100%; height: 100%; object-fit: cover; }
    }
  }

  .user-area {
    top: 15px;
    right: 15px;

    .user-info-box .user-dropdown-menu {
      width: 240px;
    }
  }

  .navbar {
    margin-bottom: 20px;

    .nav-list {
      gap: 8px;
    }

    .nav-item a {
      padding: 8px 15px;
      font-size: 14px;
    }
  }

  .developer-card {
    flex-direction: column;
    text-align: center;

    .developer-avatar {
      margin-right: 0 !important;
      margin-bottom: 20px;
    }

    .developer-links {
      justify-content: center;
    }
  }

  .tech-grid {
    grid-template-columns: 1fr !important;
  }
}

@media (max-width: 480px) {
  .user-area {
    .login-entry .login-button {
      padding: 6px 15px;
      font-size: 13px;
    }

    .user-info-box .user-dropdown-menu {
      width: 220px;
    }
  }

  .navbar .nav-item a {
    padding: 6px 12px;
    font-size: 13px;

    .nav-icon {
      margin-right: 5px;
    }
  }

  .section-title {
    font-size: 20px !important;
  }

  .developer-details {
    h3 {
      font-size: 20px !important;
    }

    .developer-desc {
      font-size: 14px !important;
    }
  }

  .developer-links {
    flex-direction: column;
    gap: 10px !important;
  }
}




.floating-button-container {
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.floating-button {

  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: #409EFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 56px;
  height: 56px;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: scale(0.95);
  }
}

.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  z-index: -1;
  /* 确保在内容层下方 */
  // filter: brightness(0.7);
  /* 适当降低亮度增加可读性 */

  /* 如果需要覆盖渐变效果 */

}

/* 在style部分添加备案号样式 */
.footer-record {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
  padding: 8px 0;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.2);
  
  .record-text {
    font-size: 12px;
    letter-spacing: 0.5px;
    
    a {
      text-decoration: none;
      transition: opacity 0.3s;
      
      &:hover {
        opacity: 0.8;
        text-decoration: underline;
      }
    }
  }
}
</style>